export const OrderProvider = {
	PayPal: 'PayPal',
};
